
import React, { FunctionComponent } from 'react';
import { Form, Card, Input, Upload, Button, Row, Col, Tag } from 'antd';
import { FormInstance } from 'antd/es/form';
import { upload } from '../service';
import get from 'lodash/get';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
// import styles from '../index.module.less';

const uploadProps = {
  accept: 'image/*,.pdf',
  maxCount: 1,
  customRequest: ({ file, onSuccess }) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const fileName = file.name;
      const suffixPos = fileName.lastIndexOf('.');
      const name = fileName.slice(0, suffixPos);
      const suffix = fileName.slice(suffixPos + 1);
      upload({
        file: e.target.result as string,
        name,
        suffix,
      }).then(res => {
        onSuccess({
          url: res.download_url
        }, file);
      });
    };
    reader.readAsDataURL(file);
  },
}

interface UploadContentProps {
  label: string;
}

const UploadContent: FunctionComponent<UploadContentProps> = ({ label, children }) => {
  return (
    <Row
      style={{ width: 520 }}
      justify="space-between"
      align="middle"
    > 
      <Col style={{ lineHeight: '32px' }}>
        {label}
      </Col>
      <Col style={{ textAlign: 'right' }}>
        {children}
      </Col>
    </Row>
  )
}

const normFile = (e: any) => {
  return e.fileList;
};
const rules = [{ required: true, message: '必填' }];

interface AuditFieldResultProps {
  result: 1 | 0;
}
const AuditFieldResult: FunctionComponent<AuditFieldResultProps> = ({ result }) => {
  return (
    <>
      {result === 1 && <><CheckCircleOutlined style={{ color: '#52c41a' }} /> <Tag color="success">审核通过</Tag></>}
      {result === 0 && <><ExclamationCircleOutlined style={{ color: '#f5222d' }} /> <Tag color="error">审核拒绝</Tag></>}
    </>
  )
}

interface QualificationProps {
  className: string;
  editable: boolean;
  form: FormInstance;
  auditResult: object;
  showAuditResult: boolean;
}

export const Qualification: FunctionComponent<QualificationProps> = ({ showAuditResult, form, editable, className, auditResult = {} }) => {
  const result = form.getFieldsValue();
  return (
    <Card className={className} bordered={false} title="资质信息" size="small">
      <Form.Item
        valuePropName="fileList"
        getValueFromEvent={normFile}
        label="基本信息"
        colon={false}
        name="license"
        rules={rules}
        extra={showAuditResult && <AuditFieldResult result={auditResult['license']} />}
      >
        <Upload {...uploadProps} disabled={!editable}>
          <UploadContent label={"营业执照"}>
            {editable ? <Button type="link" size="small">上传</Button> : get(result, ['license', 0, 'url'])}
          </UploadContent>
        </Upload>
      </Form.Item>
      <Form.Item
        label="财务信息"
        colon={false}
        name="creditProve"
        valuePropName="fileList"
        getValueFromEvent={normFile}
        rules={rules}
        extra={showAuditResult && <AuditFieldResult result={auditResult['creditProve']} />}
      >
        <Upload {...uploadProps} disabled={!editable}>
          <UploadContent label={"银行开具的资信证明（3个月内）"}>
          {editable ? <Button type="link" size="small">上传</Button> : get(result, ['creditProve', 0, 'url'])}
          </UploadContent>
        </Upload>
      </Form.Item>
      <Form.Item
        label="管理体系认证"
        colon={false}
        name="qualitySystem"
        valuePropName="fileList"
        getValueFromEvent={normFile}
        rules={rules}
        extra={showAuditResult && <AuditFieldResult result={auditResult['qualitySystem']} />}
      >
        <Upload {...uploadProps} disabled={!editable}>
          <UploadContent label={"有效期内的iso9001质量体系认证"}>
            {editable ? <Button type="link" size="small">上传</Button> : get(result, ['qualitySystem', 0, 'url'])}
          </UploadContent>
        </Upload>
      </Form.Item>
      <Form.Item
        label="供货业绩"
        colon={false}
        name="supplyContract"
        valuePropName="fileList"
        getValueFromEvent={normFile}
        rules={rules}
        extra={showAuditResult && <AuditFieldResult result={auditResult['supplyContract']} />}
      >
        <Upload {...uploadProps} disabled={!editable}>
          <UploadContent label={"近期直流充电桩供货合同"}>
            {editable ? <Button type="link" size="small">上传</Button> : get(result, ['supplyContract', 0, 'url'])}
          </UploadContent>
        </Upload>
      </Form.Item>
      <Form.Item
        label="销售发票"
        colon={false}
        name="invoice"
        valuePropName="fileList"
        getValueFromEvent={normFile}
        rules={rules}
        extra={showAuditResult && <AuditFieldResult result={auditResult['invoice']} />}
      >
        <Upload {...uploadProps} disabled={!editable}>
          <UploadContent label={"销售发票复印件"}>
            {editable ? <Button type="link" size="small">上传</Button> : get(result, ['invoice', 0, 'url'])}
          </UploadContent>
        </Upload>
      </Form.Item>
      <Form.Item
        label="场地"
        colon={false}
        name="rentContract"
        valuePropName="fileList"
        getValueFromEvent={normFile}
        rules={rules}
        extra={showAuditResult && <AuditFieldResult result={auditResult['rentContract']} />}
      >
        <Upload {...uploadProps} disabled={!editable}>
          <UploadContent label={"土地使用权证、房屋产权证或租赁合同（租赁期限为一年及以上）"}>
            {editable ? <Button type="link" size="small">上传</Button> : get(result, ['rentContract', 0, 'url'])}
          </UploadContent>
        </Upload>
      </Form.Item>
      <Form.Item label="人员构成" colon={false} required>
        <Row gutter={20}>
          <Col span={6}>
            <Form.Item name="electricalEngineer">
              <Input placeholder="电器工程师" size="small" readOnly={!editable} />
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item
              label="电器工程师"
              colon={false}
              name="electricalEngineerContract"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              rules={rules}
              extra={showAuditResult && <AuditFieldResult result={auditResult['electricalEngineerContract']} />}
            >
              <Upload {...uploadProps} disabled={!editable}>
                {editable ? <Button type="link" size="small">上传</Button> : get(result, ['electricalEngineerContract', 0, 'url'])}
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={6}>
            <Form.Item name="structuralEngineer">
              <Input placeholder="结构工程师" size="small" readOnly={!editable} />
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item
              label="结构工程师"
              colon={false}
              name="structuralEngineerContract"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              rules={rules}
              extra={showAuditResult && <AuditFieldResult result={auditResult['structuralEngineerContract']} />}
            >
              <Upload {...uploadProps} disabled={!editable}>
                {editable ? <Button type="link" size="small">上传</Button> : get(result, ['structuralEngineerContract', 0, 'url'])}
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={6}>
            <Form.Item name="softwareEngineer">
              <Input placeholder="嵌入式软件工程师" size="small" readOnly={!editable} />
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item
              label="嵌入式软件工程师"
              colon={false}
              name="softwareEngineerContract"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              rules={rules}
              extra={showAuditResult && <AuditFieldResult result={auditResult['softwareEngineerContract']} />}
            >
              <Upload {...uploadProps} disabled={!editable}>
                {editable ? <Button type="link" size="small">上传</Button> : get(result, ['softwareEngineerContract', 0, 'url'])}
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>
      <Form.Item label="试验检测管理" colon={false} required>
        <Form.Item
          name="regulatoryRegimeFiles"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          rules={rules}
          extra={showAuditResult && <AuditFieldResult result={auditResult['regulatoryRegimeFiles']} />}
        >
          <Upload {...uploadProps} disabled={!editable}>
            <UploadContent label={"试验室管理制度文件"}>
              {editable ? <Button type="link" size="small">上传</Button> : get(result, ['regulatoryRegimeFiles', 0, 'url'])}
            </UploadContent>
          </Upload>
        </Form.Item>
        <Form.Item
          name="operateProcess"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          rules={rules}
          extra={showAuditResult && <AuditFieldResult result={auditResult['operateProcess']} />}
        >
          <Upload {...uploadProps} disabled={!editable}>
            <UploadContent label={"试验检测操作规程"}>
              {editable ? <Button type="link" size="small">上传</Button> : get(result, ['operateProcess', 0, 'url'])}
            </UploadContent>
          </Upload>
        </Form.Item>
        <Form.Item
          name="testStandard"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          rules={rules}
          extra={showAuditResult && <AuditFieldResult result={auditResult['testStandard']} />}
        >
          <Upload {...uploadProps} disabled={!editable}>
            <UploadContent label={"试验检测标准"}>
              {editable ? <Button type="link" size="small">上传</Button> : get(result, ['testStandard', 0, 'url'])}
            </UploadContent>
          </Upload>
        </Form.Item>
        <Form.Item
          name="initialData"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          rules={rules}
          extra={showAuditResult && <AuditFieldResult result={auditResult['initialData']} />}
        >
          <Upload {...uploadProps} disabled={!editable}>
            <UploadContent label={"试验检测原始记录（提供1个订单的试验数据原始记录）"}>
              {editable ? <Button type="link" size="small">上传</Button> : get(result, ['initialData', 0, 'url'])}
            </UploadContent>
          </Upload>
        </Form.Item>
      </Form.Item>
      <Form.Item label="售后服务" colon={false} required>
        <Form.Item
          name="equipmentPhoto"
          help="主要设备包括：示波器、BMS模拟器、CAN记录分析仪、直流负载、耐压仪、绝缘电阻测试仪"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          rules={rules}
          extra={showAuditResult && <AuditFieldResult result={auditResult['equipmentPhoto']} />}
        >
          <Upload {...uploadProps} disabled={!editable}>
            <UploadContent label={"资产证明：主要设备/铭牌照片"}>
              {editable ? <Button type="link" size="small">上传</Button> : get(result, ['equipmentPhoto', 0, 'url'])}
            </UploadContent>
          </Upload>
        </Form.Item>
        <Form.Item
          name="equipmentInspectionCertificate"
          help="试验中使用的计量器具及检测设备具备有效期内合格的检定/校准证书或检测报告"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          rules={rules}
          extra={showAuditResult && <AuditFieldResult result={auditResult['equipmentInspectionCertificate']} />}
        >
          <Upload {...uploadProps} disabled={!editable}>
            <UploadContent label={"需要送检的检测设备检定/校准证书"}>
              {editable ? <Button type="link" size="small">上传</Button> : get(result, ['equipmentInspectionCertificate', 0, 'url'])}
            </UploadContent>
          </Upload>
        </Form.Item>
      </Form.Item>
      <Form.Item label="试验检测设备" colon={false} required>
        <Form.Item
          name="opsManual"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          rules={rules}
          extra={showAuditResult && <AuditFieldResult result={auditResult['opsManual']} />}
        >
          <Upload {...uploadProps} disabled={!editable}>
            <UploadContent label={"运维保养手册"}>
              {editable ? <Button type="link" size="small">上传</Button> : get(result, ['opsManual', 0, 'url'])}
            </UploadContent>
          </Upload>
        </Form.Item>
        <Form.Item
          name="standingBook"
          valuePropName="fileList"
          getValueFromEvent={normFile}
          rules={rules}
          extra={showAuditResult && <AuditFieldResult result={auditResult['standingBook']} />}
        >
          <Upload {...uploadProps} disabled={!editable}>
            <UploadContent label={"备品备件台账"}>
              {editable ? <Button type="link" size="small">上传</Button> : get(result, ['standingBook', 0, 'url'])}
            </UploadContent>
          </Upload>
        </Form.Item>
      </Form.Item>
    </Card>
  );
}